__turbopack_context__.v({
  "alligned-content": "TopNav-module-scss-module__X91Piq__alligned-content",
  "menu-icon-container": "TopNav-module-scss-module__X91Piq__menu-icon-container" + " " + "TopNav-module-scss-module__X91Piq__navbar-icon",
  "nav-content": "TopNav-module-scss-module__X91Piq__nav-content",
  "navbar": "TopNav-module-scss-module__X91Piq__navbar",
  "navbar-content": "TopNav-module-scss-module__X91Piq__navbar-content",
  "navbar-icon": "TopNav-module-scss-module__X91Piq__navbar-icon",
  "offline-warning": "TopNav-module-scss-module__X91Piq__offline-warning",
  "page-option-button": "TopNav-module-scss-module__X91Piq__page-option-button",
  "page-option-button-icon": "TopNav-module-scss-module__X91Piq__page-option-button-icon",
  "page-options": "TopNav-module-scss-module__X91Piq__page-options",
});
